// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"b1960058","122":"a545f9ff","412":"2d4caa7d","656":"b1960058","757":"b1960058","888":"5b6565bb","981":"b1960058"}[chunkId] + ".chunk.css";
};